import accountReducerMap from 'wanderu-ducks-account';

import AirportShuttlesGuide from '../containers/AirportShuttlesGuide';
import reducerMap from '../ducks';

function onLoad(module, info, props, context) {
    context.store.inject({
        ...reducerMap,
        ...accountReducerMap,
    });
}

export { onLoad };
export default AirportShuttlesGuide;
